import React, { useEffect } from "react";
import { isMobile } from "utils/helpers";

/**
 * This component is to show the Recaptcha badge on the UI.
 * By default this is hidden (checkout index.html grecaptcha-badge style)
 *
 * Note that the visibility of the component does not manage the recaptcha availability.
 * This only handles the badge visibility. Even with visibility hidden silent recaptch will
 * continue to work
 */
const ShowRecaptcha = ({ showBadgeForMobile = true }) => {
  const setRecaptchaBadgeVisibility = visibility => {
    try {
      const element = document.querySelector(".grecaptcha-badge");
      if (element?.style?.visibility) {
        element.style.visibility = visibility ? "visible" : "hidden";
      }
    } catch (e) {
      console.debug("Recaptcha element not found.", e);
    }
  };
  useEffect(() => {
    if (isMobile()) {
      setRecaptchaBadgeVisibility(showBadgeForMobile);
    } else {
      setRecaptchaBadgeVisibility(true);
    }

    return () => {
      setRecaptchaBadgeVisibility(false);
    };
  }, [showBadgeForMobile]);

  return <React.Fragment />;
};

export default ShowRecaptcha;
